module.exports = __webpack_public_path__ + "3912d567becf3691c43cb37576deea83.png";